import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/strategy', label: 'Strategy' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/investors', label: 'Investors' },
    { path: '/community', label: 'Community' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || location.pathname !== '/'
            ? 'bg-white border-b border-[#D9D9D6]'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1440px] mx-auto px-20">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/c46a7615a0d0ecdd59932abe918c09f8.png"
                alt="Martell Investment Capital"
                className="h-12 w-auto"
              />
            </Link>

            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-[15px] font-medium transition-all duration-300 relative pb-1 whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-[#1F2A44]'
                      : isScrolled || location.pathname !== '/'
                      ? 'text-[#1F2A44] hover:text-[#B89C4B]'
                      : 'text-white hover:text-[#B89C4B]'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {link.label}
                  {location.pathname === link.path && (
                    <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-5 h-0.5 bg-[#B89C4B]"></span>
                  )}
                </Link>
              ))}
            </nav>

            <Link
              to="/investors"
              className="hidden lg:block px-6 py-2.5 bg-[#B89C4B] text-[#1F2A44] text-[15px] font-medium rounded transition-all duration-300 hover:bg-[#1F2A44] hover:text-white whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Investor Inquiries
            </Link>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
                isScrolled || location.pathname !== '/' ? 'text-[#1F2A44]' : 'text-white'
              }`}
              aria-label="Toggle menu"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setIsMobileMenuOpen(false)}></div>
          <div className="absolute top-20 right-0 w-64 bg-white shadow-xl">
            <nav className="flex flex-col p-6 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-[15px] font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'text-[#B89C4B]'
                      : 'text-[#1F2A44] hover:text-[#B89C4B]'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/investors"
                className="mt-4 px-6 py-2.5 bg-[#B89C4B] text-[#1F2A44] text-[15px] font-medium rounded text-center transition-all duration-300 hover:bg-[#1F2A44] hover:text-white whitespace-nowrap cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Investor Inquiries
              </Link>
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;